import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app.config';
import {AppComponent} from './app.component';
import MSALInstanceFactory from '@/core/msal/instance.factory';
import {initializeMsal} from '@/core/msal/initializeApp';

// MSAL queda listo ANTES de que Angular arranque: guards, interceptor y servicios leen la cuenta
// desde el primer instante sin poder adelantarse a `initialize()`. Ver `initializeApp.ts`.
initializeMsal(MSALInstanceFactory())
    // Si la inicialización falla igual se arranca la app: con la pantalla en blanco el usuario no
    // tiene ni siquiera cómo reintentar el login, y `MsalGuard` sabe lidiar con la sesión ausente.
    .catch((err) => console.error('No se pudo inicializar MSAL', err))
    .then(() => bootstrapApplication(AppComponent, appConfig))
    .catch((err) => console.error(err));
